export default __webpack_public_path__ + "static/media/books-60.fe110810.jpg";